import {createApp} from 'vue'
import gsap from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

const plansScopeApp = createApp({
    name: "Scope switcher",
    data() {
        return {
            scope: 'monthly'
        }
    },
    methods: {
        setScope(scope) {
            this.scope = scope;

            if (scope === 'yearly') {
                let gap = 4;
                if(window.innerWidth > 768) gap = 8;
                gsap.to('.bkg-plate', {duration: 0.3, x: this.calcTransform("x", "calc(100% + " + gap + "px)"), ease: "power4.out"});
            }
            if (scope === 'monthly') {
                gsap.to('.bkg-plate', {duration: 0.3, x: 0, ease: "power4.out"});
            }
            // Dispatch event to notify other components
            const event = new CustomEvent('scopeChange', {detail: {scope: this.scope}});
            window.dispatchEvent(event);

        },
        calcTransform(property, value) {
            let alias = {y: "translateY", x: "translateX", z: "translateZ", rotation: "rotate"};
            return function (i, target) {
                let transform = target.style.transform; // remember the original transform
                target.style.transform = (alias[property] || property) + "(" + value + ")"; // apply the new value
                let computed = parseFloat(gsap.getProperty(target, property, property.substr(0, 3) === "rot" ? "deg" : "px", true)); // grab the pixel value
                target.style.transform = transform; // revert
                gsap.getProperty(target, property, "px", true); // reset the cache so the new value is reflected
                return computed;
            };
        }

    },
    mounted() {

    }
});

let plansScopeAppEl = document.querySelector('.plansScopeApp');
if (plansScopeAppEl) {
    plansScopeApp.mount(plansScopeAppEl);
}


// -------------------------------------------------------- //
// -------------------------------------------------------- //
// -------------------------------------------------------- //
// -------------------------------------------------------- //
// -------------------------------------------------------- //
// -------------------------------------------------------- //


const plansTableApp = createApp({
    name: "Plans table",
    data() {
        return {
            appReady: false,
            plans: window.amandaPlans,
            features: window.amandaFeatures,
            scope: 'monthly'
        }
    },
    computed: {},
    watch: {},
    methods: {
        setScope(scope) {
            this.scope = scope;
        },
        getPrice(plan, forceMonthly = false) {
            let price;
            if (this.scope === 'monthly') price = plan.price.monthly;
            if (this.scope === 'yearly') price = plan.price.yearly;
            if (forceMonthly) price = plan.price.monthly;

            if(!price.length) return '&nbsp;';

            price = parseFloat(price).toLocaleString('en-US');

            price = '€' + price + ' /mo';

            if(this.scope === 'yearly') {
                let monthlyPrice12Months = plan.price.monthly * 12;
                let yearlyPrice = plan.price.yearly * 12;

                price = parseFloat(yearlyPrice).toLocaleString('en-US');
                price = '€' + price + ' /year';

                if (forceMonthly) {
                    price = parseFloat(monthlyPrice12Months).toLocaleString('en-US');
                    price = '€' + price + ' /year';
                }
            }

            if (plan.price.price_prepend && !forceMonthly) {
                price = plan.price.price_prepend + ' ' + price;
            }

            if(plan.slug === 'plan_0' && this.scope === 'yearly') {
                return 'Only available with monthly payments';
            }

            return price;

        },
        /*
        getSelectedFeatures(plan) {
            let selectedFeatures = this.features.items.filter(feature => plan.features.includes(feature.id));

            // Update features and set active if included in plan
            selectedFeatures = selectedFeatures.map(feature => {
                feature.status = feature.plan_status[plan.slug].txt !== '' ? feature.plan_status[plan.slug].txt : feature.plan_status[plan.slug].active;
                return feature;
            });

            return selectedFeatures;
        }

         */

    },
    components: {},
    mounted() {
        // Add event listener to listen for scope change
        window.addEventListener('scopeChange', (event) => {
            this.setScope(event.detail.scope);
        });

        this.appReady = true;
    }
});

let plansTableAppEl = document.querySelector('.plansTableApp');
if (plansTableAppEl) {
    plansTableApp.mount(plansTableAppEl);
}


// -------------------------------------------------------- //
// -------------------------------------------------------- //
// -------------------------------------------------------- //
// -------------------------------------------------------- //
// -------------------------------------------------------- //
// -------------------------------------------------------- //


const featureListApp = createApp({
    name: "Feature list",
    data() {
        return {
            appReady: false,
            plans: window.amandaPlans,
            features: window.amandaFeatures,
            scope: 'monthly',
            search: '',
            listScrollPos: null,
        }
    },
    computed: {
        featureList() {
            let list = [];

            // order all features by their category
            this.features.categories.forEach(cat => {
                let featureList = this.features.items.filter(feature => feature.categories.includes(cat.id));
                // If search is active, filter the featureList by search term
                if (this.search.length) {
                    featureList = featureList.filter(feature => feature.title.toLowerCase().includes(this.search.toLowerCase()));
                }
                if (featureList.length) {
                    list.push({
                        category: cat,
                        items: featureList,
                        serviceTitleBefore: cat.is_service || false,
                    });
                }
            });


            // Make sure only the one category has serviceTitleBefore active (only the first)
            let serviceTitleSet = false;
            list.forEach(cat => {
                if (cat.serviceTitleBefore && !serviceTitleSet) {
                    serviceTitleSet = true;
                } else {
                    cat.serviceTitleBefore = false;
                }
            });


            return list;
        }
    },
    watch: {
        search(newSearch) {

            let element = document.querySelector('#feature-list-start');
            let offset = element.getBoundingClientRect();
            window.scrollBy(0, offset.top)

        }
    },
    methods: {
        init() {

            // Remove Enterprice plan and all references to it
            //this.plans = this.plans.filter(plan => plan.slug !== 'plan_3');
            // Remove plan from features status
            this.features.items.forEach(feature => {
             //   delete feature.plan_status['plan_3'];
            });




            // Set all categories to open from start if on desktop
            if (window.innerWidth > 768) {
                this.features.categories.forEach(cat => {
                    cat.open = true;
                });


                ScrollTrigger.create({
                    id: "featureListPin",
                    trigger: ".feature-list",          // the section that holds your sticky + content
                    pin: ".head",            // the element to pin (can also be true to pin trigger)
                    start: "top top",             // when the section hits the top of the viewport
                    end: () => "+=" + document.querySelector(".feature-list .main-list").offsetHeight,
                    // pinSpacing: true,             // adds push space like sticky would
                    // end: "bottom top",   // or a fixed distance
                    pinSpacing: false,   // 🚀 prevents extra whitespace
                    // scrub: true,               // only if you want animations tied to scroll
                    // markers: true,             // uncomment for debugging
                });

            }

        },
        setScope(scope) {
            this.scope = scope;
        },
        getPrice(plan) {
            let price;
            if (this.scope === 'monthly') price = plan.price.monthly.toLocaleString();
            if (this.scope === 'yearly') price = plan.price.yearly.toLocaleString();

            price = parseFloat(price).toLocaleString('en-US');

            price = '€' + price + ' /mo';


            if(this.scope === 'yearly') {
                let monthlyPrice12Months = plan.price.monthly * 12;
                let yearlyPrice = plan.price.yearly * 12;

                price = parseFloat(yearlyPrice).toLocaleString('en-US');
                price = '€' + price + ' /year';
            }

            if (plan.price.price_prepend) {
                price = plan.price.price_prepend + ' ' + price;
            }

            if(plan.slug === 'plan_0' && this.scope === 'yearly') {
                return 'Only available with monthly payments';
            }


            return price;
        },
        toggleCat(cat) {
            cat.category.open = !cat.category.open;
        },
        getStatus(plan) {
            if(plan){
                return plan.txt !== '' ? plan.txt : plan.active;
            }
        },
        getStatusPlanName(key) {
            let plan = this.plans.find(plan => plan.slug === key);
            if(plan) return plan.title;
            //return this.plans[index].title;
        }

    },
    components: {},
    mounted() {
        this.init();

        //console.log(this.plans);
        //console.log(this.features);

        //console.log(this.featureList);

        // Add event listener to listen for scope change
        window.addEventListener('scopeChange', (event) => {
            this.setScope(event.detail.scope);
        });

        this.appReady = true;
    }
});

let featureListAppEl = document.querySelector('.featureListApp');
if (featureListAppEl) {
    featureListApp.mount(featureListAppEl);
}